// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__29GUz","overlay":"Modal_overlay__3EyGr","modal_content":"Modal_modal_content__1LxJl","flex":"Modal_flex__klSfQ"};